module.exports = __webpack_public_path__ + "img/join_img3.5ba5f02a.jpg";